<template>
  <div>
    <table>
      <tr>
        <td valign="top">Enabled:</td>
        <td>
          <label class="switch">
            <input type="checkbox" v-model="notifications">
            <span class="slider round"></span>
          </label>
        </td>
      </tr>
      <tr>
        <td valign="top">Emails:</td>
        <td>
          <div v-for="(email, index) in notificationEmails" :key="index">
            <input type="input" v-model="email.value" size="50">
          </div>
          <button @click="newNotificationEmail">Add</button>
        </td>
      </tr>
    </table>
    <button @click="cancel()">Cancel</button>
    <button @click="save()">Save</button>
  
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
export default {
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      notifications: false,
      notificationEmails: []
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    account: {
      handler (){
         this.init()
      },
      deep: true
    }
  },
  methods: {
    cancel () {
      this.init()
    },
    save () {
      var params = {
        notifications: this.notifications,
        notification_emails: this.getNotificationEmails()
      }
      this.$store.dispatch('saveAccountSettings', { account: this.account, params: params })
    },
    init () {
      if (!this.account.settings) return
      let settings = this.account.settings
      this.notifications = settings.notifications
      this.notificationEmails = []
      for (var email in settings.notification_emails) {
        this.notificationEmails.push({value: settings.notification_emails[email]})
      }
    },
    getNotificationEmails () {
      var emails = []
      for (var email in this.notificationEmails) {
        if (this.notificationEmails[email].value)
          emails.push(this.notificationEmails[email].value)
      }
      return emails
    },
    newNotificationEmail () {
      this.notificationEmails.push({value: ''})
    }
  }
}
</script>
